import { useWindowSizing } from '@hooks/useSizeWindow';
import dynamic from 'next/dynamic';

const DesktopFooter = dynamic(() => import('./Desktop'));
const MobileFooter = dynamic(() => import('./Mobile'));

const Footer = (): JSX.Element => {
  const mobileWindow = useWindowSizing(990);
  return !mobileWindow ? <DesktopFooter /> : <MobileFooter />;
};

export default Footer;
